import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import ContextApi from "../../../HOC/ContextsAPI/ContextApi";

function PageNotFound() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/404Error");
  }, [show, navigate]);

  const navigateToDashboard = () => {
    Cookies.get("adminToken") ? navigate("/") : navigate("/login");
  };
  const redirectTologin = () => {
    Cookies.remove("adminToken");
    navigate("/login");
  };
  console.log(Cookies.get("c_user"));
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-gray-50 px-4">
      <div className="text-6xl font-bold text-gray-300 mb-4">404</div>
      <div className="text-xl text-gray-600 font-medium text-center mb-8">
        Page not found
      </div>
      <p className="text-gray-500 text-center mb-12 max-w-md">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      {!Cookies.get("adminToken") ? (
        <button
          onClick={() => redirectTologin()}
          className="px-6 py-3 bg-sidebar hover:bg-slate-800 text-white font-medium rounded-lg transition-colors"
        >
          Go to login
        </button>
      ) : (
        <button
          onClick={() => navigateToDashboard()}
          className="px-6 py-3 bg-sidebar hover:bg-slate-800 text-white font-medium rounded-lg transition-colors"
        >
          Go to dashboard
        </button>
      )}
    </div>
  );
}

export default PageNotFound;
